module.exports = __webpack_public_path__ + "static/media/SF-UI-Text-Light.3168e17c.woff2";